import { getConfig as getUrlConfig } from '../../../url-reader';
import { useEffect } from 'react';
import { globalConfig } from '../../../shared/config/config';

const useTitle = (): void => {
  const { title } = getUrlConfig();

  useEffect(() => {
    if (document && !document.querySelector('title')) {
      const titleElement = document.createElement('title');
      titleElement.text = title ? title : globalConfig.defaultTintTitle;
      document.getElementsByTagName('head')[0].appendChild(titleElement);
    }
  }, [title]);
};

export default useTitle;
